import React from 'react';
import { Modal, Input } from 'components';
import { DocumentType } from '../types';
import DocumentsContext from '../DocumentsContext';

type RenameModalProps = Pick<DocumentType, 'id' | 'name'> & {
  setRenameModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
};

const RenameModal: React.FC<RenameModalProps> = ({
  id,
  name,
  setRenameModalOpen,
}) => {
  const { rename } = React.useContext(DocumentsContext);

  const extractedName = name.replace(/\.[^.]+$/g, '');
  const [newName, setNewName] = React.useState(extractedName);
  const [invalid, setInvalid] = React.useState(false);

  const handleChange = ({
    target: { value },
  }: React.ChangeEvent<HTMLInputElement>) => {
    setInvalid(false);
    setNewName(value);
  };

  const saveEdits = () => {
    const extension = name.replace(extractedName, '');
    rename(`${newName}${extension}`, id);
    setRenameModalOpen(false);
  };

  const checkInvalid = () => {
    if (!newName) {
      setInvalid(true);
      return;
    }
    saveEdits();
  };

  return (
    <Modal
      title="Rename"
      onOk={checkInvalid}
      onCancel={() => setRenameModalOpen(false)}
      visible
    >
      <Input
        label="Name"
        error={invalid}
        onChange={handleChange}
        value={newName}
      />
    </Modal>
  );
};

export default RenameModal;
